import { PaginatedResponse, User } from 'types/common_types';
import { createSlice } from '@reduxjs/toolkit';

interface userState {
  user_loading: boolean;
  users: PaginatedResponse<User> | null;
  user_detail: User | null;
  delete_loading: boolean;
}

const initialState: userState = {
  users: null,
  user_detail: null,
  user_loading: false,
  delete_loading: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserLoading: (state, action) => {
      state.user_loading = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setUserDetail: (state, action) => {
      state.user_detail = action.payload;
    },
    setDeleteLoading: (state, action) => {
      state.delete_loading = action.payload;
    },
  },
});

export const { setUserLoading, setUsers, setUserDetail, setDeleteLoading } = userSlice.actions;

export default userSlice.reducer;
